export default {"src":"https://www.levande.com.au/_next/static/media/map-pin.1e8e9587.svg","height":66,"width":46,"blurWidth":0,"blurHeight":0};